module.exports = __webpack_public_path__ + "img/logo-9.a3481ed9.png";